// Action types
import * as actionTypes from "../actionTypes/notifications.types";

export const toggleNotificationsPanel = () => {
  return {
    type: actionTypes.TOGGLE_NOTIFICATIONS_PANEL
  };
};

export const closeNotificationsPanel = () => {
  return {
    type: actionTypes.CLOSE_NOTIFICATIONS_PANEL
  };
};

export const fetchNotifications = ({ from } = {}) => {
  return {
    type: actionTypes.FETCH_NOTIFICATIONS_REQUEST,
    from
  };
};

export const fetchNotificationsSuccess = (notifications, hasMore, append) => {
  return {
    type: actionTypes.FETCH_NOTIFICATIONS_SUCCESS,
    notifications,
    hasMore,
    append
  };
};

export const fetchUnreadCount = () => {
  return {
    type: actionTypes.FETCH_UNREAD_COUNT_REQUEST
  };
};

export const fetchUnreadCountSuccess = count => {
  return {
    type: actionTypes.FETCH_UNREAD_COUNT_SUCCESS,
    count
  };
};

export const markNotificationSeen = id => {
  return {
    type: actionTypes.MARK_NOTIFICATION_SEEN_REQUEST,
    id
  };
};

export const markAllNotificationsSeen = () => {
  return {
    type: actionTypes.MARK_ALL_NOTIFICATIONS_SEEN_REQUEST
  };
};

export const viewNotification = id => {
  return {
    type: actionTypes.VIEW_NOTIFICATION_REQUEST,
    id
  };
};

export const newNotificationReceived = notification => {
  return {
    type: actionTypes.NEW_NOTIFICATION_RECEIVED,
    notification
  };
};

export const fetchEnabledNotifications = () => {
  return {
    type: actionTypes.FETCH_ENABLED_NOTIFICATIONS_REQUEST
  };
};

export const fetchEnabledNotificationsSuccess = enabled => {
  return {
    type: actionTypes.FETCH_ENABLED_NOTIFICATIONS_SUCCESS,
    enabled
  };
};

export const updateEnabledNotifications = prefs => {
  return {
    type: actionTypes.UPDATE_ENABLED_NOTIFICATIONS_REQUEST,
    prefs
  };
};

export const updateEnabledNotificationsSuccess = enabled => {
  return {
    type: actionTypes.UPDATE_ENABLED_NOTIFICATIONS_SUCCESS,
    enabled
  };
};
